import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { getAbsenceColor } from "~/modules/dashboard/components/TimeTrackingCalendar/entryStyles.ts";
import { normalizeTKey } from "~/types/typeHelpers.ts";

type Props = {
	absenceName: string;
	size?: "sm";
	isOpen?: boolean;
	onClick?: () => void;
};

/** An absence as a row with the type name in bold, on a light tint of the type color. A row without `onClick` is plain. */
export function AbsenceRow({ absenceName, size, isOpen, onClick }: Props) {
	const { t } = useTranslation();
	const color = getAbsenceColor(absenceName);
	const className = clsx(
		"w-full truncate rounded text-left font-semibold",
		// The normal size sits in the day list: its px-3 matches the closed `TrackingEntryRow` card.
		size === "sm" ? "px-1.5 py-0.5 text-[11px] leading-4" : "px-3 py-2 text-sm",
		color.tint,
		color.text,
		isOpen && ["ring-2 ring-offset-1", color.ring],
	);
	const label = t(normalizeTKey("entities:absenceType." + absenceName));

	return onClick ? (
		<button type="button"
				className={className}
				onClick={onClick}>{label}</button>
	) : (
		<div className={className}>{label}</div>
	);
}
